import { render, staticRenderFns } from "./MaterialLinks.vue?vue&type=template&id=debf6312"
import script from "./MaterialLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports